<template>
   <footer
      class="footer border-top border-danger bg-white"
   >
      <div class="container">
         <div class="row justify-content-center">
            <div class="col-xs-12 col-lg-8 text-center">
               <p class="mb-1">
                  &copy; {{ year }} Sanchopan Terminal de buses B/ La Pradera - Montería - Córdoba
               </p>
               <p class="mb-1">
                  Teléfonos: <span class="text-nowrap">783 50 60</span> - <span class="text-nowrap">783 41 52</span> - <span class="text-nowrap">310 627 7803</span>
               </p>
            </div>
         </div>
      </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
   
</style>
